import { render, staticRenderFns } from "./DeliveryIssue.vue?vue&type=template&id=643db6c4"
import script from "./DeliveryIssue.vue?vue&type=script&lang=js"
export * from "./DeliveryIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports